import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
})
export class SelectItemComponent{

  @Input() dropStyle = false;

  @Input() title;

  @Input() itens;

  @Input() item;

  @Input() processLabel = (item) => {
    return item.nome;
  }

  @Output() itemChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(){
  }
  
  compareWithFn(item1, item2) {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  changed(){
    this.itemChange.emit(this.item);
  }

  select(_item){
    this.item = _item;
    this.changed();
  }
}
